/// <reference types="vite/client" />
import axios from "axios";

/**
 * Create an API client for Okta-authenticated requests.
 *
 * @param baseURL - Base URL for API requests (default: "/api")
 * @param timeout - Request timeout in milliseconds (default: 10000)
 * @returns Configured axios instance
 */
export function createAPIClient(
  baseURL: string = "/api",
  timeout: number = 10000
) {
  const client = axios.create({
    baseURL,
    timeout,
    withCredentials: true,
  });

  // Add request interceptor for logging in development
  client.interceptors.request.use((config) => {
    if (import.meta.env.DEV) {
      console.log("API Request:", config.method?.toUpperCase(), config.url);
    }
    return config;
  });

  // Add response interceptor for error handling
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (import.meta.env.DEV) {
        console.error("API Error:", error.response?.status, error.response?.data);
      }

      // For Okta auth, 401/403 errors should be handled by the frontend
      // The RequireAuth component will redirect to login if needed
      // No need for IAP-style redirects here

      return Promise.reject(error);
    }
  );

  return client;
}

// Default client instance
export const apiClient = createAPIClient();

export default apiClient;
